module.exports = __webpack_public_path__ + "static/img/fruit_bra_2.3fda017.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/art/drawing_painting/fruit_bra_2.jpg
// module id = hYU7
// module chunks = 1